'use client';
import { Container, Row, Col, Placeholder } from 'react-bootstrap';

export default function Loading() {
  return (
    <Container className="mt-5 mb-5" fluid>
      <Row>
        <Col xs={12}>
          <Placeholder
            xs={12}
            style={{ height: '540px', marginBottom: '20px' }}
          />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Placeholder
            sm={6}
            style={{ height: '340px', marginBottom: '20px' }}
          />
          <Placeholder sm={6} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder sm={6} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder sm={6} style={{ marginBottom: '20px' }} size="lg" />
          <Placeholder sm={6} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6} md={4}>
          <Placeholder xs={12} style={{ height: '220px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <Placeholder xs={12} style={{ height: '220px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <Placeholder xs={12} style={{ height: '220px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <Placeholder xs={12} style={{ height: '220px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <Placeholder xs={12} style={{ height: '220px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
        <Col xs={12} sm={6} md={4}>
          <Placeholder xs={12} style={{ height: '220px' }} />
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
        </Col>
      </Row>
    </Container>
  );
}
